/**
 * Вывод блока сравнения
 *
 * @package citrus.vue.product.compare
 */
import {Vue} from "ui.vue";
import {rest} from "rest.client";
import {store} from "citrus.vuex.store";
import SITE_CONFIG from 'citrus.config';

Vue.component("CitrusProductCompare", {
	template: `
		<a 
			v-if="product"
			href="javascript:void(0)"
			class="" :class="[{'active':inCompare}, classObject, class_css]" 
			@click="addProductToCompare"
		>
			<svg v-html="iconHtml"></svg>
			<span v-if="title" v-html="title"></span>
		</a>
	`,
	store: store,
	props: {
		class_css: {
			type: String,
			default: "productcard__first--compare"
		},
		title: {
			type: [String, Boolean],
			default: false
		},
		product: [Number, String],
		in_compare: {
			type: Boolean,
			default: false
		},
		icon: {
			id: {
				type: String,
				default: "",
			},
			class_css: {
				type: String,
				default: "",
			}
		},
		storage: {
			type: String,
			default: 'input'
		},
		ajax: {
			type: Boolean,
			default: false
		},
		selectFields: {
			type: [Array, Object],
			default: () => {
				return ['DETAIL_PICTURE','PREVIEW_PICTURE'];
			}
		}
	},
	data: function () {
		return {
			isCompare: false
		};
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("CITRUS_VUE_PRODUCT_COMPARE_");
		},
		classObject: function () {
			let cssClass = [];
			cssClass.push(this.icon.class_css);

			if(this.inCompare) {
				cssClass.push('active');
			}
			return cssClass;
		},
		inCompare: function() {
			let inCompare = false;
			switch(this.storage) {
				case 'vuex':
						inCompare = this.$store.getters['compare/check'](this.product);
					break;
				case 'input':
						inCompare = true === this.in_compare;
					break;
				default:
					inCompare = this.isCompare;
			}

			return inCompare;
		},
		iconHtml: function() {
			return '<use x="0" y="0" xlink:href="' + SITE_CONFIG.SVG_PATH + '#' + this.icon.id + '" ></use>';
		}
	},
	mounted: function () {
		if('event' === this.storage) {
			// если товар удален из сравнения
			Vue.event.$on("Citrus.Vue.Product.Compare:remove:" + this.product, () => {
				this.isCompare = false;
			});

			// если товар уже добавлен в сравнение
			Vue.event.$on("Citrus.Vue.Product.Compare:check:" + this.product, () => {
				this.isCompare = true;
			});
		}
	},
	beforeDestroy() {
		Vue.event.$off("Citrus.Vue.Compare:remove:" + this.product);
		Vue.event.$off("Citrus.Vue.Compare:check:" + this.product);
	},
	created: function() {

	},
	updated: function () {},
	methods: {
		addProductToCompare: function() {
			if(true === this.inCompare) {
				this.$store.dispatch('compare/remove', this.product);
			}
			else
			{
				this.$store.dispatch('compare/add', this.product);
			}

			return false;
		},
		sendAjaxRequest: function() {
			rest.callMethod("citrus.compare.add", {
					id: this.product,
					select: this.selectFields
				}, (response) => {
					this.loading = false;
					if (
						!response.answer.result || !response.answer.hasOwnProperty("result") || response.answer.hasOwnProperty("error")
					) {
						console.info(response.answer);
						return;
					}

					this.onAfterAdd();
				}
			);
		},
		onAfterAdd: function() {
			switch(this.storage) {
				case 'vuex':
						this.$store.dispatch('compare/add', this.product);
					break;
				default:
					this.isCompare = true;
					Vue.event.$emit("Citrus.Vue.Compare:check:" + this.product);
			}

			// отправляем событие всем кто слушает что товар успешно добавлен в сравнение
			Vue.event.$emit("Citrus.Vue.Compare:add");
		}
	}
});
